const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getUsageSummary(orgId, filters = {}) {
  const params = new URLSearchParams();
  if (filters.from) params.append('from', filters.from);
  if (filters.to) params.append('to', filters.to);
  if (filters.siteId) params.append('siteId', filters.siteId);
  if (filters.assetId) params.append('assetId', filters.assetId);
  if (filters.programId) params.append('programId', filters.programId);
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/usage/summary${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch usage summary');
  }
  
  return response.json();
}

export async function createUsageExport(orgId, filters = {}) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/exports/usage`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(filters)
  });
  
  if (!response.ok) {
    throw new Error('Failed to create usage export');
  }
  
  const data = await response.json();
  return data.exportJob;
}

export async function getExportJobs(orgId, filters = {}) {
  const params = new URLSearchParams();
  if (filters.type) params.append('type', filters.type);
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/exports${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch export jobs');
  }
  
  const data = await response.json();
  return data.exportJobs;
}
